import { ACCOUNT_CHOICE_ENABLED } from '../config/features.js';

/**
 * Whether the driver said they have a GreenCharge account.
 *
 * Persisted on the session so the answer survives the /auth round trip, and
 * so the returning-vehicle prompt in ChargeSetup can stay quiet for a driver
 * who has already declined once.
 */
export const ACCOUNT_CHOICE = Object.freeze({
  ACCOUNT: 'account',
  GUEST: 'guest',
});

/** A driver who explicitly chose to continue without signing in. */
// Gated by the rollout flag, so a 'guest' answer persisted by a flag-ON build
// can never steer an OFF build past the plate screen (flag switched between
// loads). With the screen off, nobody has answered the question.
export const isGuestChoice = (value) => ACCOUNT_CHOICE_ENABLED && value === ACCOUNT_CHOICE.GUEST;
